import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react'
import { deleteWIEvent } from '../../../apiclients/streamsapi_bridge';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

function DeleteWIEventType(props) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false)
    async function removeThisUser(e) {
        console.log(props.deleteWIObj);
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(true);
        let deleteUSer = await deleteWIEvent(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            props.useragent, props.deleteWIObj.event_id
        );
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        let deleteMsg = await deleteUSer.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            
        } else if(deleteMsg.status == "success"){
            props.setRerender(true);
            props.setSuccessMessage(deleteMsg.message);
            props.onClose();
        }
    }
    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <div>
                <span className="phrecording">{t("RemoveWIEventTypetxt")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisUser(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
        </>
    );
};


export default DeleteWIEventType
